import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'box-footer',
    templateUrl: './box-footer.component.html',
    styleUrls: ['./box-footer.component.scss'],
    standalone: false
})
export class BoxFooterComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
